import { render, staticRenderFns } from "./v-pill-shape-form-image.vue?vue&type=template&id=4f15f818"
import script from "./v-pill-shape-form-image.vue?vue&type=script&lang=js"
export * from "./v-pill-shape-form-image.vue?vue&type=script&lang=js"
import style0 from "./v-pill-shape-form-image.vue?vue&type=style&index=0&id=4f15f818&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports